// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../../pplx/frontend/api-clients/core/client.js';
export const autosuggestGeneralClient = createTypedClient();
export const createAutosuggestGeneralClient = (config) => createTypedClient(config);
